import { render } from "./OnlyBenefits.vue?vue&type=template&id=1fd37a62&ts=true"
import script from "./OnlyBenefits.vue?vue&type=script&lang=ts"
export * from "./OnlyBenefits.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__